// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + (chunkId === 143 ? "app" : chunkId) + "." + {"143":"ecaff48d455abb471331","278":"9228fa63c98606c83d4c"}[chunkId] + ".css";
};